/**
 * Firebase client configuration selector.
 *
 * This module is pure and testable: it does not import the Firebase SDK or
 * initialize any apps. The actual initialization lives in src/firebase.js.
 *
 * Selection is explicit via REACT_APP_FIREBASE_TARGET:
 *   - "production" (or unset) -> barterx-swap
 *   - "sandbox"               -> nexterzone-sandbox
 * Unknown values fail closed so there is never a silent fallback to production.
 */

export const FIREBASE_TARGETS = {
  PRODUCTION: "production",
  SANDBOX: "sandbox",
};

const PRODUCTION_CONFIG = {
  apiKey: "AIzaSyBSCXsn0Yu4vfshoHuIDYu2dviz7E38pWI",
  authDomain: "nexterzone.com",
  projectId: "barterx-swap",
  storageBucket: "barterx-swap.firebasestorage.app",
  messagingSenderId: "157140536078",
  appId: "1:157140536078:web:69e6d0fe995bffd4e3655f",
  measurementId: "G-R89D5GD3XY",
};

const SANDBOX_CONFIG = {
  apiKey: "AIzaSyBwUtVQDdmM-9mnDY_aiD5s9tdH8CVtbno",
  authDomain: "nexterzone-sandbox.firebaseapp.com",
  projectId: "nexterzone-sandbox",
  storageBucket: "nexterzone-sandbox.firebasestorage.app",
  messagingSenderId: "418749494719",
  appId: "1:418749494719:web:e58028870773c7738a9d0a",
  measurementId: "G-GTTDTWV9L5",
};

const ALLOWED_TARGETS = new Set([
  FIREBASE_TARGETS.PRODUCTION,
  FIREBASE_TARGETS.SANDBOX,
  "", // explicit empty string is treated as production default
]);

export function resolveFirebaseConfig(target = process.env.REACT_APP_FIREBASE_TARGET) {
  const normalized = String(target ?? "").trim();

  if (!ALLOWED_TARGETS.has(normalized)) {
    throw new Error(
      `Unknown REACT_APP_FIREBASE_TARGET "${normalized}". ` +
        `Use "${FIREBASE_TARGETS.PRODUCTION}" or "${FIREBASE_TARGETS.SANDBOX}".`
    );
  }

  return normalized === FIREBASE_TARGETS.SANDBOX ? SANDBOX_CONFIG : PRODUCTION_CONFIG;
}

export { PRODUCTION_CONFIG, SANDBOX_CONFIG };
